<template>
  <v-card id="section-booking">
    <v-alert id="alert-tab" type="error" v-if="alert!==false" dismissible>
      {{ alert }}
    </v-alert>
    <div class="header-card">
      <h3>Booking</h3>
    </div>
<!--    <div id="tab-calendar"> -->
    <div id="booking-container">
      <v-row
        class="marg-pad-null"
        v-for="(itemBookingTime, indexBookingTime) in bookingTimeArr"
        :key = "indexBookingTime"

      >
        <v-col class="col-buttons">
          <v-btn
              elevation="2"
              class="buttons-booking-tab button-time"
              v-on:click="choiceTime(itemBookingTime)"
          >
            {{itemBookingTime}}
          </v-btn>
        </v-col>
        <v-col class="col-buttons"  v-if= "itemBookingTime===btnSchedule?true:false">
          <v-btn
              elevation="2"
              class="buttons-booking-tab button-confirm"
              v-on:click="scheduleMeeting"
          >
            Confirm
          </v-btn>
        </v-col>
      </v-row>

    </div>
  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex';
  import moment from 'moment-timezone';
  import xlooLib from "../xlooLib/xlooLib";
  export default {
    name: "tabBooking",
    data(){
      return{
        alert : false,
        bookingTimeArr : [],
        bookingDate : '',
        btnSchedule : '',
      }
    },
    computed : {
    ...mapGetters(['dateBooking', 'timeZoneLead', 'storeWorkedTime']),
    },
    watch : {
      dateBooking: function(){
 //       console.log('change dateBooking-->', this.dateBooking, this.$store.getters.dateBooking);
        this.bookingTimeArr = this.$store.getters.storeWorkedTime[this.dateBooking];
        console.log('this.dateBooking tab arr-->', this.dateBooking);
      },
      timeZoneLead: function(){
        this.bookingTimeArr = this.$store.getters.storeWorkedTime[this.dateBooking];
      },
      storeWorkedTime: function(){
        this.bookingTimeArr = this.$store.getters.storeWorkedTime[this.dateBooking];
        console.log('storeWorkedTime=', this.$store.getters.storeWorkedTime);
      },
      visiblePage: function(){

      },

    },
    mounted : function() {
      this.bookingTimeArr = this.$store.getters.storeWorkedTime[this.dateBooking];
      console.log('storeWorkedTime=', this.$store.getters.storeWorkedTime);
 //     console.log(this.dateBooking);

    },
    methods : {
      choiceTime(choiceTime){
        this.btnSchedule = choiceTime;
      },
      async scheduleMeeting(){
        const dateSchedule =  xlooLib.dateOfTimeZone(
            moment(this.dateBooking).format('YYYY'),
            moment(this.dateBooking).format('MM'),
            moment(this.dateBooking).format('DD'),
            moment(this.dateBooking + ' ' +  this.btnSchedule, 'YYYY/MM/DD h:mm A').format("HH:mm"),
            this.$store.getters.timeZoneLead);
        console.log('  dateSchedule-->', dateSchedule);

        const dataReq = {
          hash : this.$store.getters.hash,
          date : moment(dateSchedule).utc().utcOffset(this.$store.getters.timeZoneUser).format("YYYY-MM-DD"),
          time : moment(dateSchedule).utc().utcOffset(this.$store.getters.timeZoneUser).format("HH:mm")
        }
        console.log('dataReq = ', dataReq);
        // eslint-disable-next-line no-unused-vars
//        let actionLoading = true;
        this.$root.$emit("loadingTrue");
        const resSchedule = await this.$store.dispatch("set_preliminaryBooking", dataReq);
//        actionLoading = false;
        this.$root.$emit("loadingFalse");

        if(typeof resSchedule.error !== 'undefined'){
          this.alert = resSchedule.description
          return
        } else {
          this.$store.commit("set_dateBooking", dateSchedule);
          this.$root.$emit("schedule");
        }

      }
    }
  }
</script>

<style scoped>
  #section-booking {
    margin-left: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
/*    width: 100%;*/
    width: 200px;
  }
  .header-card {
    height: 88px;
    background-color: #2a6ebb;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 16px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    width: 100%;
  }
  .header-card h3 {
    line-height: 34px;
    font-size: 34px;
    color: #fff;
    font-weight: 500;
  }
  #booking-container {
    overflow-y: auto;
    overflow-x: hidden;
    height: auto;
    max-height: 365px;
  }
  #booking-container .buttons-booking-tab{
    background-color: #fff;
  }
  .button-time{
    width: 100%;
  }
  #booking-container .button-confirm{
    width: 100%;
    background-color: #f5f5f5;
    padding: 0;
  }
  .col-buttons{
    padding: 0;
  }
  #alert-tab{
    margin-bottom: 0;
  }
  @media (max-width: 960px) {
    #section-booking{
      margin-left: 0;
    }
  }
</style>
